module.exports = __webpack_public_path__ + "static/media/logo_qualdo-rix.3db663db.svg";